
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Vizualizace',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Zadejte číslo',
	'maxValuePlaceholder': 'Zadejte číslo',
	'customRangeErrorMessage': 'Hodnota musí být číslo',
	'propFillColor': 'Barva výplně',
	'propBorderColor': 'Barva ohraničení',
	'propColorPalette': 'Aktuální paleta barev',
	'propColorPaletteChangeLabel': 'Změnit paletu barev',
	'propNewColorPaletteLabel': 'Vytvořit vlastní paletu barev',
	'propNewHeatPaletteLabel': 'Vytvoření vlastní teplotní paletu',
	'propDonutRadius': 'Poloměr prstence',
	'showTitleLabel': 'Zobrazit nadpis',
	'titleTypeLabel': 'Typ nadpisu',
	'smartTitleLabel': 'Inteligentní nadpis',
	'customTitleLabel': 'Vlastní nadpis',
	'noTitleLabel': 'Bez nadpisu',
	'propHeatScalePalette': 'Aktuální teplotní paleta',
	'propHeatPaletteChangeLabel': 'Změnit teplotní paletu',
	'propMaintainAxisScales': 'Zachovat měřítka osy',
	'propLineAndSymbolColor': 'Barva čáry a symbolu',
	'propLineAndSymbolPalette': 'Paleta barev čar a symbolů',
	'propElementColor': 'Barva prvku',
	'propColumnColor': 'Barva sloupce',
	'propColumnPalette': 'Paleta barev sloupců',
	'propColumnHeatPalette': 'Teplotní paleta sloupců',
	'propBarColor': 'Barva pruhu',
	'propGoalColor': 'Barva cíle',
	'propToColor': 'Do barvy',
	'propFromColor': 'Od barvy',
	'propNumberValidationErrorMessageId': 'Zadejte číslo',
	'fontSizeAuto': 'Automaticky',
	'propAutoBinCount': 'Počet skupin',
	'propAutoBinToggle': 'Automatické seskupení',
	'tabName_general': 'Obecné',
	'tabName_visDetails': 'Podrobnosti',
	'tabName_animation': 'Animace',
	'tabName_mediaDetails': 'Podrobnosti médií',
	'tabName_webDetails': 'Podrobnosti webové stránky',
	'tabName_imageDetails': 'Podrobnosti obrazu',
	'tabName_visualization': 'Vizualizace',
	'tabName_text': 'Text',
	'sectionName_colorsAndThemes': 'Barva a motivy',
	'sectionName_appearance': 'Vzhled',
	'sectionName_general': 'Obecné',
	'sectionName_colorPalette': 'Barva',
	'sectionName_axis': 'Osa',
	'sectionName_axis_label': 'Osa',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Graf',
	'sectionName_regionLayer': 'Vrstva regionů',
	'sectionName_pointLayer': 'Vrstva bodů',
	'sectionName_latLongLayer': 'Vrstva zeměpisné šířky/délky',
	'sectionName_pathLayer': 'Vrstva cesty',
	'propTransparencyDescription': 'Nastaví objekt více nebo méně průhledný. Zadejte hodnotu v rozsahu 0 až 100.',
	'smart_annotation_unauthorized': 'Anotace: neautorizovaný přístup',
	'smart_annotation_method': 'Anotace: metoda není povolena',
	'smart_annotation_media': 'Anotace: typ média není povolen',
	'smart_annotation_input': 'Anotace: neplatný vstup',
	'smart_annotation_internal': 'Anotace: interní systémová chyba',
	'smart_annotation_generic_error': 'Anotace: chyba služby',
	'smart_annotation_dialog_title': 'Náhledy',
	'smart_errors': 'Chyby anotací:',
	'smart_warnings': 'Varování anotací:',
	'smart_annotation_insight_icon_title': 'Náhledy',
	'smart_annotations_toggle_on': 'Zapnout náhledy',
	'smart_annotations_toggle_off': 'Vypnout náhledy',
	'smart_annotation_insight_unavailable': 'Náhledy nejsou aktuálně k dispozici.',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Náhled nejsou k dispozici, pokud se používá filtr Horní % nebo Dolní %.',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognóza není k dispozici, pokud se používá filtr Horní % nebo Dolní %.',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Náhled nejsou k dispozici, pokud se používá filtr Horní nebo Dolní a v poli je víc než jeden sloupec.',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognóza není k dispozici, pokud se používá filtr Horní nebo Dolní a v poli je víc než jeden sloupec.',
	'forecast_title': 'Prognóza',
	'forecast_toggle_on': 'Zapnout prognózu',
	'forecast_toggle_off': 'Vypnout prognózu',
	'statDetailsPerspectiveTitle': 'Analýza',
	'emptyStatDetailsPanel': 'Pro aktuální vizualizaci není k dispozici žádná další analýza.',
	'predict_errors': 'Chyby analýzy',
	'predict_warnings': 'Varování analýzy',
	'fpd_invalid_data_source': 'Tento zdroj dat nemá přiřazený inteligentní modul',
	'fpd_network_issue': 'Při provádění analýzy pro tento zdroj dat došlo k problému',
	'fpd_data_source_category': 'Chybějící modul Smarts',
	'fpd_response_errors': 'Chyby doporučeného drivery',
	'fpd_response_warnings': 'Varování doporučeného drivery',
	'catalyst_service_bad_request': 'Chybný požadavek',
	'catalyst_service_unkown_Id': 'Nalezeno neznámé ID požadavku',
	'catalyst_service_internal_server_error': 'Interní chyba serveru',
	'catalyst_service_generic_error': 'Chyba služby Catalyst',
	'catalyst_service_error': 'Tato služba aktuálně není k dispozici.',
	'propLegendPosition': 'Poloha legendy',
	'propLeft': 'Vlevo',
	'propRight': 'Vpravo',
	'propTop': 'Horní',
	'propBottom': 'Dole',
	'propNone': 'Žádný',
	'propLegendDisplay': 'Zobrazit legendu',
	'targetThicknessPlaceHolder': '%{min} k %{max}',
	'targetThicknessErrorMsg': 'Zadejte celé číslo v rozsahu od %{min} do %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Drivery (vybráno:',
	'possibleKeyDriver_DialogDriversLabelEnd': ')',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Obnovit výchozí hodnoty',
	'possibelKeyDriver_AddNewDrivers': 'Přidat další drivery',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Hledat a přidat další drivery',
	'possibleKeyDrivers_MaxPossibleReached': 'Zrušte výběr některých driverů pro přidání nebo vyberte jiné',
	'possibleKeyDrivers_Recommended': 'Doporučeno',
	'visRecommendedTypes': 'Doporučené typy vizualizace',
	'visRecommender_smartsfailure': 'doporučení vizualizace nejsou aktuálně k dispozici',
	'visMore': 'Další...',
	'visMoreTooltip': 'Další vizualizace',
	'visOtherTypes': 'Jiné typy vizualizace',
	'visChange': 'Změnit vizualizace',
	'automaticTypeCaption': 'Automaticky',
	'propVisType': 'Typy vizualizace',
	'dlg_loading': 'Načítání...',
	'snippetListChartCaption': 'Seznam úseků kódu',
	'convoClusterChartCaption': 'Klastr konverzace',
	'areaChartCaption': 'Plošný',
	'barChartCaption': 'Pruhový',
	'columnChartCaption': 'Sloupcový',
	'stackedbarChartCaption': 'Skládaný pruhový',
	'stackedcolumnChartCaption': 'Skládaný sloupcový',
	'bubbleChartCaption': 'Bublinový',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analýza driverů',
	'scatterChartCaption': 'Bodový',
	'lineChartCaption': 'Čárový',
	'pointChartCaption': 'Jednoduchý bodový',
	'heatChartCaption': 'Mapa využití',
	'bulletChartCaption': 'Střelový',
	'waterfallChartCaption': 'Kaskádový',
	'pieChartCaption': 'Výsečový',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radiální',
	'compositeChartCaption': 'Čára a sloupec',
	'wordCloudChartCaption': 'Shluk slov',
	'networkChartCaption': 'Síťový',
	'relationshipNetworkChartCaption': 'Vztahová síť',
	'treemapChartCaption': 'Stromová mapa',
	'packedBubbleChartCaption': 'Sbalený bublinový',
	'hierarcicalPackedBubbleChartCaption': 'Bublina hierarchie',
	'spiralChartCaption': 'Spirálový',
	'decisionTreeChartCaption': 'Rozhodovací strom',
	'legacyMapChartCaption': 'Starší mapa',
	'sunburstChartCaption': 'Paprskový',
	'visUsageComparison': 'Porovnání',
	'visUsageRelationships': 'Vztahy',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Části k celku',
	'visUsageGeospatial': 'Geoprostorová vizualizace',
	'visUsageAdvanced': 'Rozšířená analýza',
	'visUsageTablesAndSummary': 'Tabulky a souhrn',
	'visUsageSocialInsights': 'Náhledy sociálních sítí',
	'visUsageOther': 'Ostatní',
	'autoBinActionText': 'Automatické seskupení',
	'filterAutobinActionText': 'Filtrovat přihrádky',
	'memberCalculationActionText': 'Výpočet člena',
	'toolbarActionCalculation': 'Výpočet',
	'toolbarActionEditCalculation': 'Upravit výpočet',
	'topBottomRankLabel': 'Očíslování pořadí (%{label})',
	'toolbarDeleteFilterActionText': 'Odebrat filtr',
	'toolbarActionTopKeyDrivers': 'Zobrazit drivery',
	'toolbarActionCustomGroup': 'Vlastní skupina',
	'canNotCreateCustomGroup': 'Tuto vlastní skupinu nelze vytvořit.',
	'aria_label_datatable': 'Tabulka dat',
	'summaryCaption': 'Souhrn',
	'MeasuresCaption': 'Ukazatele',
	'MeasuresGroupCaption': 'Skupina ukazatelů (%{count})',
	'ValuesCaption': 'Hodnoty',
	'turnInsightsOn': 'Zapnout náhledy',
	'turnInsightsOff': 'Vypnout náhledy',
	'decisionRules': 'Pravidla',
	'decisionTree': 'Stromový diagram',
	'decisionSunburst': 'Stromový paprskový graf',
	'switchToDecisionRules': 'Přepnout na rozhodovací pravidla',
	'switchToDecisionTree': 'Přepnout na rozhodovací strom',
	'data_group_less_then': 'menší než %{rangeTo}',
	'data_group_to': '%{rangeFrom} až < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} a výše',
	'nullValueContent': '(bez hodnoty)',
	'sum': 'Suma',
	'count': 'Počet',
	'countdistinct': 'Počet jedinečných',
	'avg': 'Průměr',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Vlastní',
	'variance': 'Odchylka',
	'stddev': 'Směrodatná odchylka',
	'median': 'Medián',
	'calculated': 'Vypočteno',
	'none': 'Žádný',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Scénář s výzvou není aktuálně podporován.',
	'preAggregateLabel': 'Použít hodnoty výzvy k zadání ze zdroje dat',
	'postAggregateLabel': 'Použít hodnoty výzvy k zadání v sestavě',
	'preAggregateText': 'Rozsah používá hodnoty ve zdroji dat, nikoli hodnoty zobrazené na panelu dashboard.',
	'defaultAggregation_count': 'Počet',
	'defaultAggregation_countdistinct': 'Počet jedinečných',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Průměr',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Automaticky (%{aggregationType})',
	'keydriver_average': 'Celkový průměr',
	'keydriver_up_down': 'Zvýrazněné skupiny s vysokými nebo nízkými hodnotami průměru mají na cíl větší vliv. Skupiny s neobvykle vysokými nebo nízkými hodnotami průměru mají největší vliv.',
	'keydriver_different': 'Rozložení pro zvýrazněné skupiny se výrazně liší od celkového rozložení. Tyto skupiny mají na cíl větší vliv.',
	'topOperator': 'Horní',
	'bottomOperator': 'Dole',
	'topBottomFact': '%{operator} %{value}%{percent} podle %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Odstranit počet pro začátek nebo konec',
	'deleteTopBottomPercent': 'Odstranit procenta pro začátek nebo konec',
	'topBottomTitle': 'Pouze tento objekt',
	'deleteTopBottom': 'Odstranit počet pro začátek nebo konec',
	'editTopBottom': 'Upravit počet pro začátek nebo konec',
	'editTopBottomCount': 'Upravit počet pro začátek nebo konec',
	'editTopBottomPercent': 'Upravit procenta pro začátek nebo konec',
	'ariaDeleteTopBottomCountLabel': 'Stisknutím klávesy Delete lze počet pro začátek nebo konec odstranit.',
	'ariaDeleteTopBottomPercentLabel': 'Stisknutím klávesy Delete lze procenta pro začátek nebo konec odstranit.',
	'ariaEditTopBottomCountLabel': 'Stisknutím klávesy Enter lze počet pro začátek nebo konec upravit.',
	'ariaEditTopBottomPercentLabel': 'Stisknutím klávesy Enter lze procenta pro začátek nebo konec upravit.',
	'ariaDeleteDrillStateLabel': 'Stisknutím klávesy Enter lze počet pro začátek nebo konec upravit.',
	'drillUpStateTitle': 'Přechod o úroveň výš',
	'drillDownStateTitle': 'Přejít o úroveň níž',
	'ariaEditTopBottomLabel': 'Stisknutím klávesy Enter lze počet pro začátek nebo konec upravit.',
	'ariaDeleteTopBottomLabel': 'Stisknutím klávesy Delete lze počet pro začátek nebo konec odstranit.',
	'allKeyDriversLabel': 'Automaticky (všechny drivery)',
	'filter_drag_and_drop_single_dock': 'Přetáhněte data sem, aby se filtrovala.',
	'filter_drag_and_drop_all_tabs': 'Přetáhněte data sem, aby se filtrovaly všechny karty.',
	'filter_drag_and_drop_current_tab': 'Přetáhněte data sem, aby se filtrovala tato karta.',
	'filter_empty_consume_mode': 'Nebyly použity žádné filtry.',
	'filterClearAllItems': 'Vymazat všechny filtry',
	'filterDeleteAllItems': 'Odstranit všechny filtry',
	'filterDockChevronLeft': 'Posouvat se daty',
	'filterDockChevronRight': 'Posouvat se daty',
	'filterIconLabel_Single': 'Filtry',
	'filterIconLabel_Global': 'Všechny karty',
	'filterIconLabel_Tab': 'Tato karta',
	'filterIconTooltip_Single': 'Filtry',
	'filterIconTooltip_Global': 'Filtry pro všechny karty',
	'filterIconTooltip_Tab': 'Filtry pro tuto kartu',
	'filterDropZoneTooltip_Single': 'Zóna umístění filtru',
	'filterDropZoneTooltip_Global': 'Zóna umístění filtru pro všechny karty',
	'filterDropZoneTooltip_Tab': 'Zóna umístění filtru pro tuto kartu',
	'filterOverflowMenu': 'Další',
	'expand': 'Rozbalit',
	'collapse': 'Sbalit',
	'filterDockItemNameAriaLabel': 'Stisknutím klávesy Enter spustíte dialogové okno filtrování a definujete filtr.',
	'filterItemCanvasMove': 'Přidat na plátno',
	'filterItemDelete': 'Odstranit filtr',
	'filterInvertRange': 'všechno kromě: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ne po %{from}',
	'filter_date_after': 'Po %{from}',
	'filter_date_before_except': 'Ne před %{to}',
	'filter_date_before': 'Před %{to}',
	'filter_date_between_except': 'Ne mezi %{from}-%{to}',
	'filter_date_between': 'Mezi %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Vše',
	'filterExcept': 'kromě %{values}',
	'filterDockToolbarButtonLabel': 'Ukotvení filtru',
	'navigateTitle': 'Přejít do umístění',
	'current_nav_group': 'Aktuální navigační skupina je %{navigation_group_name}',
	'next': 'Další',
	'previous': 'Předchozí',
	'multiselectMsg': 'Vybráno: %{count}',
	'errMsgFilterItemMissingTitle': 'Hodnoty filtru %{itemName} nelze načíst, protože tyto hodnoty nejsou k dispozici s touto datovou sadou.',
	'errMsgFilterItemGenericTitle': 'Nelze načíst hodnoty filtru',
	'textFilterItemsNotFound': 'Nejsou k dispozici žádné položky.',
	'nullValueLabel': '(prázdné)',
	'filterConditionLabel': 'Podmínka filtru',
	'filter_includesAll': 'Zahrnuje vše',
	'filter_allMembersOfSet': 'Všechny členy sady',
	'modelFilter': 'Filtr',
	'filtersTitle': 'Vlastnosti filtru',
	'search': 'Hledat',
	'clearTextFilterValue': 'Vymazat',
	'invertFilterSelection': 'Invertovat',
	'modellingLoading': 'Načítání...',
	'searchAll': 'Najít všechny sloupce',
	'toolbarActionPossibleKeyDrivers': 'Upravit rozsah',
	'toolbarActionPossibleKeyDriversSubTitle': 'Přetáhněte položky zleva, aby se zahrnuly do diagramu analýzy driverů.',
	'toolbarActionSort': 'Řadit',
	'toolbarActionSortAscending': 'Seřadit vzestupně',
	'toolbarActionSortDescending': 'Seřadit sestupně',
	'toolbarActionSortAuto': 'Automaticky (%{sortOrder})',
	'toolbarActionSortCustom': 'Vlastní',
	'toolbarActionFormat': 'Formát',
	'toolbarActionFormatAbbreviation': 'Zkracovat',
	'toolbarActionFormatNone': 'Automaticky',
	'toolbarActionFilter': 'Filtr',
	'toolbarActionTopBottom': 'Začátek nebo konec',
	'toolbarActionRmvShape': 'Odebrat tvar',
	'toolbarActionToggleShapeDrop': 'Tvar infografiky',
	'toolbarActionToggleShapeDropTitle': 'Vytvořit infografiku',
	'toolbarActionToggleShapeDropText': 'Chcete-li vytvořit infografiku, pomocí myši do tohoto pole přetáhněte tvar.',
	'toolbarActionAggregationType': 'Shrnout',
	'toolbarDeleteActionText': 'Odebrat sloupec',
	'toolbarTextActionText': 'Formátovat text',
	'toolbarActionFilterLocalKeepSelected': 'Zachovat',
	'toolbarActionFilterLocalExcludeSelected': 'Vyloučit',
	'toolbarActionFilterAllKeepSelected': 'Filtr',
	'toolbarActionSimpleCalculation': 'Jednoduchý výpočet',
	'toolbarActionDrillBack': 'Zpět',
	'toolbarActionDrillUp': 'Přechod o úroveň výš',
	'toolbarActionDrillDown': 'Přejít o úroveň níž',
	'toolbarActionNavigate': 'Procházet',
	'toolbarActionCreateFilterGroup': 'Vytvořit nové připojení',
	'toolbarActionDisconnectFilterGroup': 'Přerušit všechny spoje',
	'toolbarActionLinkFilterGroup': 'Přidat k existujícímu připojení',
	'toolbarActionLassoSelect': 'Vybrat nástroj',
	'toolbarActionRefreshDeveloperWidget': 'Obnovit',
	'textFontFamilySubClassHairline': 'Nitková čára',
	'textFontFamilySubClassThin': 'Tenké',
	'textFontFamilySubClassThinItalic': 'Tenká kurzíva',
	'textFontFamilySubClassExtraLight': 'Velmi slabé',
	'textFontFamilySubClassExtraLightItalic': 'Velmi slabá kurzíva',
	'textFontFamilySubClassLight': 'Světlý',
	'textFontFamilySubClassLightItalic': 'Slabá kurzíva',
	'textFontFamilySubClassRegular': 'Regulární',
	'textFontFamilySubClassRegularItalic': 'Normální kurzíva',
	'textFontFamilySubClassItalic': 'Kurzíva',
	'textFontFamilySubClassMedium': 'Střední',
	'textFontFamilySubClassMediumItalic': 'Střední kurzíva',
	'textFontFamilySubClassHeavy': 'Těžké',
	'textFontFamilySubClassHeavyItalic': 'Těžká kurzíva',
	'textFontFamilySubClassDemiBold': 'Polotučné',
	'textFontFamilySubClassDemiBoldItalic': 'Polotučná kurzíva',
	'textFontFamilySubClassBold': 'Tučně',
	'textFontFamilySubClassBoldItalic': 'Tučná kurzíva',
	'textFontFamilySubClassExtraBold': 'Extra tučné',
	'textFontFamilySubClassExtraBoldItalic': 'Extra tučná kurzíva',
	'textFontFamilySubClassBlack': 'Černá',
	'textFontFamilySubClassBlackItalic': 'Černá kurzíva',
	'textFontFamilySubClassStencil': 'Šablona',
	'dlg_ascending': 'vzestupně',
	'dlg_descending': 'sestupně',
	'dlg_custom': 'vlastní',
	'dlg_none': 'žádný',
	'dlg_hierarchy': 'hierarchie',
	'dlg_namedSet': 'pojmenovaná sada',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Odebrat úchyt',
	'visualizationLabel': 'Vizualizace',
	'chartLabel': '%{chartName} graf',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Stisknutím klávesy F12 můžete procházet modulem widget.',
	'f10KeyDescription': 'Stisknutím klávesy F10 spustíte zobrazení fokusu modulu widget.',
	'playButtonLabel': 'Přehrát',
	'dataPlayerValueListLabel': 'Hodnoty přehrávače dat',
	'localFilterTitle': 'Pouze tento objekt',
	'globalFilterTitle': 'Všechny objekty',
	'deleteFilter': 'Odstranit filtr',
	'editFilter': 'Upravit filtr',
	'ariaEditFilterLabel': 'Stisknutím klávesy Enter lze filtr upravit.',
	'ariaDeleteFilterLabel': 'Stisknutím klávesy Delete lze filtr odstranit.',
	'measureFilterBetween': 'Mezi %{lowerBound} a %{upperBound}',
	'measureFilterNotBetween': 'Ne mezi %{lowerBound} a %{upperBound}',
	'dimFilterIn': 'Zahrnutí: %{in}',
	'dimFilterNotIn': 'Vyloučení: %{out}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Před %{upperBound}',
	'ariaEditPrompt': 'Po stisknutí klávesy Enter lze hodnotu výzvy k zadání upravit.',
	'dataPointFilterTitle': 'Datové body',
	'dataPointFilterIncludeSummary': 'Zahrnuté datové body: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Vyloučené datové body: %{valueCount}',
	'widgetFiltersLabel': 'Filtry modulu widget',
	'coachMarkTitleSpiralTarget': 'Upravit rozsah',
	'coachMarkContentSpiralTarget': 'Zde je k dispozici přístup k výběru drivery pro cíl a možnost jeho úprav.',
	'srILVTreeLabel': 'Seznam',
	'geomapUnrecognizedLocations': 'Nerozpoznaná umístění:',
	'geomapAmbiguousLocations': 'Nejednoznačné oblasti:',
	'visualizationNotifications': 'Oznámení o vizualizaci:',
	'dataNotifications': 'Oznámení dat:',
	'autobinSuggestion': 'Zapnout automatické seskupení',
	'LIVE_empty_visualization_hint_title': 'Sestavit vlastní vizualizaci',
	'LIVE_empty_visualization_hint_description': 'Přetáhněte data sem nebo na pole.',
	'LIVE_slots_required_field_description': '%{asterisk} Označuje povinné pole',
	'LIVE_slots_drag_and_drop_description': 'Přetáhněte data do polí nahoře, aby se sestavila a filtrovala vizualizace.',
	'dwErrorLoadingAvailableVisualizations': 'Nelze načíst dostupné definice zobrazení',
	'moreDataIndicator': 'Vaše data byla oříznuta po %{threshold} položkách. Chcete-li zobrazit méně položek, použijte filtr.',
	'nonCtxTopBottomInvalid': 'Definování počátečního nebo koncového pravidla bez kontextu není pro kontingenční tabulky podporováno. Došlo k odebrání z tohoto zobrazení kontingenční tabulky. Znovu definujte pravidlo pro jednu nebo několik kategorií v kontextu sloupce %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Nelze načíst objekt, jelikož mu chybí definice vizualizace.',
	'dwErrorLoadingVisualizationListNotFound': 'Nelze načíst vizualizaci.',
	'dwErrorRunningQuery': 'Nelze načíst data ze sad %{datasetName}.',
	'dwErrorGeoData': 'Máme problémy se zobrazením geografických údajů na mapě. Zvolte jiný typ vizualizace.',
	'dwPromptSignonCancelWarning': 'Data pro tuto vizualizaci nejsou k dispozici. Poskytněte správná pověření.',
	'dwErrorMissingDataset': 'Nelze načíst vizualizaci, protože má přidruženou nedostupnou datovou sadu \'%{datasetName}\'.',
	'dwErrorRenderingVisualization': 'Nelze načíst tuto vizualizaci.',
	'dwErrorVisualizationTooSmall': 'Vizualizace je příliš malá a nemůže zobrazit v ní obsažená data. Zvětšete vizualizaci nebo omezte obsažená data.',
	'errorSourceNotFound': 'Nelze načíst vizualizaci, protože přidružený zdroj \'%{sourceName}\' není k dispozici.',
	'errorActionNotSupported': 'Tato akce není podporována pro zdroj dat \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'Vizualizace má měřítka na více hranách, což již není podporováno. Umístěte měřítka pouze na jednu hranu.',
	'errorExceedAllowableValue': 'Odhadovaný počet buněk přesahuje povolenou hodnotu 100000. Použijte filtrování na plánované sady, aby se snížil počet buněk.',
	'propScaleLabel': 'Množství ikon',
	'propScaleDescription': 'Vyberte množství ikon.',
	'propScaleFew': 'Nízké',
	'propScaleDefault': 'Výchozí',
	'propScaleMany': 'Vysoké',
	'lastRefresh': 'Poslední aktualizace: před %{timeInterval}',
	'widgetTimer': 'Časovač modulu widget',
	'datasetItemsUnavailable': 'Některé datové sady použité v této vizualizaci jsou nedostupné.',
	'datasetItemUnavailable': 'Tato položka datové sady je nedostupná',
	'retry': 'Opakovat akci',
	'widgetConditionalFormatLabel': 'Přepnout ovládací prvky podmíněného formátování',
	'widgetConditionalFormatTitle': 'Upravit barvu podmíněného formátování',
	'conditionalPalettePickerLabel': 'Rozdělení hodnot pro: %{title}',
	'HistogramYAxisTitle': 'Počet',
	'crosstabName': 'Kontingenční tabulka',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Není k dispozici',
	'summaryLabel': '%{label} s hodnotou %{value}',
	'infographicLabel': '%{label} s hodnotou %{value}',
	'warning': 'Varování',
	'swapRowsAndColumns': 'Prohodit řádky a sloupce',
	'hideSummariesLabel': 'Skrýt souhrny',
	'showSummariesLabel': 'Zobrazit souhrny',
	'hideRowColumn': 'Skrýt',
	'showAllRowColumn': 'Zobrazit vše',
	'dataAssetPropertiesLabel': 'Vlastnosti vizualizace',
	'evAdd': 'Přidat sloupec',
	'evCollapse': 'Sbalit',
	'evColumns': 'Sloupce',
	'evLocalFilters': 'Lokální filtry',
	'evExpand': 'Rozbalit',
	'evFilterTooltip': 'Filtr',
	'missingColumn': 'Chybí: %{columnLabel}',
	'missingFiltering': 'Chybějící filtry pro sloupce:',
	'missingDataItem': 'Odkazovaná datová položka \'%{dataItemId}\' nebyla v modulu widget nalezena.',
	'heatByLabel': 'Teplota podle:',
	'toolbarChangeVisualization': 'Změnit vizualizace',
	'modellingRelatedTablesNoneFound': 'Nebyly nalezeny žádné související tabulky',
	'processing': 'Zpracování...',
	'errorCellWarning': 'Některé souhrnné hodnoty se nepodařilo vypočítat.',
	'aggregateTypeToggler': 'Zobrazit typ agregace',
	'maxColumnsExceeded': 'Byl překročen maximální počet sloupců. Zahozené sloupce: %{columns}.',
	'unboundColumns': 'Nelze použít následující sloupce: %{columns}.',
	'unboundColumn': 'Následující sloupec nelze použít: %{columns}.',
	'recommendRequestFailed': 'Žádost o doporučení selhala. Obraťte se na administrátora.',
	'visualizationDoesNotSupportOLAP': 'Nelze vytvořit tuto vizualizaci, která je založena na zdroji dat OLAP. Použijte jiný podporovaný zdroj dat.',
	'showDataBehindVizLabel': 'Zobrazit data',
	'showDataBehindVizNotSupportedLabel': 'Zobrazení dat není pro tento typ vizualizace k dispozici',
	'exploreData': 'Prozkoumat...',
	'newExplore': 'Nové prozkoumání',
	'thumbnails_error_fetching': 'Chyba při načítání miniatur',
	'loadedThumbnailImage': 'Načtená miniatura vizualizace %{visType}',
	'autobinAxisLabel': 'skupiny',
	'recommended_visualizations': 'Doporučené vizualizace',
	'all_visualizations': 'Všechny vizualizace',
	'edit': 'Upravit',
	'selectTargetDialogTitle': 'Vyberte cíl přechodu',
	'noTargetInCM': 'Cíl přechodu nebyl nalezen.',
	'errorDrillDefinition': 'Během přidávání nebo úpravy definice přechodu došlo k potížím.',
	'errorDrillToTarget': 'Při přechodu na úroveň cíle %{targetName} došlo k chybě',
	'drillThroughMappingViewLabel': 'Přiřadit sloupce z panelu dashboard výzvám k zadání v cílové sestavě',
	'drillthroughScopeRadioLabel': 'Použít tuto definici na:',
	'drillthroughScopeRadioOptionVisualization': 'Pouze tato vizualizace',
	'drillthroughScopeRadioOptionConnection': 'Vizualizace ve stejném připojení používající stejný zdroj dat',
	'drillthroughScopeRadioOptionDashboard': 'Libovolná vizualizace v perspektivě %{perspective} používající stejný zdroj dat',
	'drillThroughParametersColumnTitle': 'Výzvy k zadání \'%{targetName}\':',
	'drillThroughMetadataColumnTitle': 'Datové sloupce položky %{boardName}:',
	'drillThroughDefinitionNoParameter': 'Pro cíl přechodu nejsou k dispozici žádné výzvy k zadání.',
	'drillThroughDefinitionErrorQueryingReport': 'Opravte problém s cílovou sestavou a pak zkuste znovu vytvořit definici přechodu.',
	'drillThroughDefinitionErrorDlgTitle': 'Došlo k chybě',
	'dlg_back': 'Přejít zpět',
	'dlg_close': 'Zavřít',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Storno',
	'dlg_apply': 'Použít',
	'drillthrough_unsaveMsg': 'Chcete pokračovat bez uložení položky %{name}?',
	'drillthrough_jumpTo': 'Definice přechodu: %{name}',
	'drillthrough_jumpToLabel': 'proskok',
	'drillthrough_manage': 'Spravovat...',
	'drillthrough_addNewTarget': 'Přidat novou definici přechodu',
	'drillthrough_manageJumpPaths': 'Spravovat definice přechodů',
	'drillthrough_manageJumpPaths_edit': 'Upravit položku %{name}',
	'drillthrough_manageJumpPaths_delete': 'Odstranit položku %{name}',
	'drillthrough_manageAddAnotherTarget': 'Přidat další definici přechodu',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Potvrdit odstranění',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Opravdu chcete odstranit přechod \'%{name}\'?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplikovat název přechodu',
	'drillthrough_definitionMessage': 'Přechod \'%{name}\' již existuje. Zadejte jiný název.',
	'drillthrough_jumpToTarget_notFound': 'Nebyl nalezen cíl pro přechod \'%{name}\'.',
	'drillThroughDefinitionNoParameterSubTitle': 'Cílové sestavě nebyl předán žádný kontext.',
	'drillthrough_titleLabel': 'Nadpis',
	'drillthrough_subTitle': 'Kontext vizualizace ve zdroji se používá k filtrování cíle %{perspective}.',
	'noPrompt': 'Bez výzvy k zadání',
	'formatAutoDescription': 'Automaticky uvádí formát zděděný z vašeho zdroje dat nebo vizualizace.',
	'formatDefaultDescription': 'Předvolba určuje formát zděděný ze systému.',
	'createCustomGroupAction': 'Vytvořit skupinu dat',
	'removeCustomGroupAction': 'Odebrat skupinu dat',
	'editCustomGroupAction': 'Upravit skupinu dat',
	'renameCustomGroupAction': 'Přejmenovat skupinu dat',
	'createCustomGroupErrorToast': 'Vaši skupinu dat nebylo možné vytvořit.',
	'removeCustomGroupErrorToast': 'Vaši skupinu dat nebylo možné odebrat.',
	'editCustomGroupErrorToast': 'Vaši skupinu dat nebylo možné upravit.',
	'renameCustomGroupErrorToast': 'Vaši skupinu dat nebylo možné přejmenovat.',
	'customGroupLabel': 'Skupina dat',
	'ungroupCustomGroupLabel': 'Zrušit seskupení',
	'renameCustomGroupLabel': 'Přejmenovat',
	'createCustomGroupLabel': 'Vytvořit',
	'customGroupingLabel': '%{columnLabel} (skupina)',
	'createCustomSort': 'Vytvořit vlastní řazení',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Vyberte dostupné položky a poté změňte jejich pořadí, abyste vytvořili vlastní řazení.',
	'availableItems': 'Dostupné položky',
	'selectAll': '(Vybrat vše)',
	'customSortOrder': 'Vlastní pořadí řazení',
	'selectAvailableItemsDesc': 'Vyberte dostupné položky, a pak zde změňte jejich uspořádání.',
	'moveToTop': 'Přesunout na začátek',
	'clear': 'Vymazat',
	'sortRemainingItemsBy': 'Řadit zbývající položky podle',
	'clearAll': 'Vymazat vše',
	'resetTooltip': 'Ze seznamu %{customSortOrder} budou odebrány všechny položky. A rozevírací nabídka %{sortRemainingItemsBy} se vrátí na výchozí nastavení.',
	'manyItemsWarning': 'Výběr mnoha položek může mít vliv na výkon vašeho panelu dashboard.',
	'manyItemsSelected': 'Bylo vybráno více položek než %{maxItems}, což může mít vliv na výkon vašeho panelu dashboard.',
	'somethingWentWrong': 'Došlo k chybě',
	'unableToLoadItems': 'Nelze načíst dostupné položky.',
	'tryAgain': 'Zkusit znovu',
	'customSortLabel': 'Vlastní řazení',
	'applyError': 'Nelze použít %{action}.',
	'searchReturnedNoResults': 'Hledání nevrátilo žádné výsledky.',
	'tryDifferentSearchTerm': 'Zkuste jiný hledaný výraz.',
	'extVisSystem': 'Systém',
	'extVisCustom': 'Vlastní',
	'customVisTestVisualization': 'Testovat vizualizaci',
	'extVisCustomVisPreview': 'náhled',
	'extVisCustomPreviewWidgets': 'Moduly widget pro vývojáře',
	'extVisCustomVVisualization': 'Vizualizace',
	'extVisCustomVisuals': 'Vlastní vizuály',
	'noPermissionToManage': 'Nemáte oprávnění ke správě vlastních vizualizací.',
	'extVisCustomUpdate': 'Aktualizovat',
	'extVisCustomDelete': 'Odstranit',
	'extVisNoCustomVisuals': 'Žádné vlastní vizualizace',
	'extVisNoCustomVisualsMsg': 'Ve vaší organizaci nejsou aktuálně žádné vlastní vizualizace',
	'extVisAddCustomVisual': 'Přidat vlastní vizuál',
	'extVisNoCustomVisualsAdminMsg': 'V současné době nejsou žádné vlastní vizuály. Začněte jeho přidáním.',
	'extVisNoSDKConnection': 'Pro lokální soubor se nevytvořilo připojení.',
	'extVisNoSDKPreviewMsg': 'Chcete-li zobrazit náhled vašich vizualizací, vytvořte připojení.',
	'extVisMore': 'Další',
	'extVisDeleteDialogTitle': 'Odstranit vlastní vizuál',
	'extVisDeleteDialogBody': 'Opravdu chcete tuto vlastní vizualizaci odstranit? Může být používána jinými panely dashboard nebo sestavami.',
	'extVisDeleteConfirmation': 'Váš vlastní vizuál byl odstraněn.',
	'extVisDeleteError': 'Váš vlastní vizuál nebylo možné odstranit. %{msg}',
	'extVisCloseToast': 'Zavřít nyní',
	'extVisAdd': 'Váš vlastní vizuál byl úspěšně přidán.',
	'extVisAddError': 'Váš vlastní vizuál nebylo možné přidat. %{msg}',
	'extVisUpdate': 'Váš vlastní vizuál byl úspěšně aktualizován.',
	'extVisUpdateError': 'Váš vlastní vizuál nebylo možné aktualizovat. %{msg}',
	'extVisAddProgress': 'Probíhá importování souboru %{name}.',
	'extVisUpdateProgress': 'Probíhá aktualizace %{name}.',
	'extPermissionTitle': 'Omezený přístup nebo odstraněný vlastní vizuál',
	'extPermissionBody': 'Tento vlastní vizuál nelze zobrazit, protože byl buď odstraněn, nebo má omezený přístup.',
	'customVizSaveWarning': 'Vaše vlastní vizuály nebylo možné uložit. Nebyly importovány.',
	'schematicTestCaption': 'Testovat schéma',
	'schematicServiceRequestError': 'Chyba služby schématu',
	'extVisPreviewMessage': 'Toto je náhled. Vizualizace dosud nebyla přidána do produktu.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Nedefinováno',
	'kpiDefaultTargetLabel': 'Cíl',
	'kpiNonNumericTarget': 'Cílová hodnota musí být číslo.',
	'kpiManualTargetSlotFilled': 'Hodnota použitá v poli',
	'kpiAutoValueSize': 'Automaticky',
	'kpiUnableDrawSparklineLabel': 'Nelze vykreslit minigraf',
	'kpiUnableDrawSparklineInfo': 'Minigraf vyžaduje minimálně dva body v čase. Změňte data nebo upravte filtry tak, aby se zobrazil minigraf.',
	'conditionalFormattingEnabled': 'Podmíněná barva',
	'currentConditionalPalette': 'Aktuální podmíněná paleta',
	'sectionName_range': 'Nastavit rozsah',
	'rangeScaleLabel': 'Měřítko',
	'rangeScalePercentage': 'Procentní',
	'rangeScaleNumeric': 'Číselný',
	'numberOfSteps': 'Počet rozsahů',
	'conditionalFormattingSelectedStep': 'Vybraný rozsah',
	'conditionalFormattingStartValue': 'Počáteční hodnota',
	'conditionalFormattingEndValue': 'Koncová hodnota',
	'conditionalFormattingTextColor': 'Barva textu',
	'conditionalFormattingMin': 'Min.',
	'conditionalFormattingMax': 'Max.',
	'conditionalFormattingNonNumericValue': 'Hodnotou musí být číslo.',
	'conditionalFormattingStepIndexInvalid': 'Index rozsahu je neplatný.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Hodnota musí být v rozsahu %{start} - %{end}.',
	'conditionalFormattingValueShouldBeLower': 'Hodnota musí být menší nebo rovna %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'Hodnota musí být větší nebo rovna %{value}.',
	'conditionalFormattingDeleteStep': 'Odebrat vybraný rozsah',
	'conditionalFormattingRestoreSteps': 'Obnovit rozsahy',
	'conditionalFormattingReversePalette': 'Obrátit barvy',
	'conditionalFormattingShapeIndicator': 'Tvar indikátoru',
	'conditionalFormattingIconNone': 'Bez tvaru',
	'conditionalFormattingIconArrowUp': 'Šipka nahoru',
	'conditionalFormattingIconArrowRight': 'Šipka vpravo',
	'conditionalFormattingIconArrowDown': 'Šipka dolů',
	'conditionalFormattingIconCaretUp': 'Stříška nahoru',
	'conditionalFormattingIconDash': 'Přerušovaná',
	'conditionalFormattingIconCaretDown': 'Stříška dolů',
	'conditionalFormattingIconCheckmark': 'Zaškrtnutí',
	'conditionalFormattingIconWarning': 'Varování',
	'conditionalFormattingIconXSymbol': 'Symbol X',
	'conditionalFormattingIconCircle': 'Kruh',
	'conditionalFormattingIconTriangle': 'Trojúhelník',
	'conditionalFormattingIconDiamond': 'Kosočtverec',
	'conditionalFormattingIconFaceSatisfied': 'Spokojený obličej',
	'conditionalFormattingIconFaceNeutral': 'Neutrální obličej',
	'conditionalFormattingIconFaceDissatisfied': 'Nespokojený obličej',
	'suppression': 'Potlačení',
	'suppressNone': 'Žádný',
	'suppressRowsAndColumns': 'Řádky a sloupce',
	'suppressRows': 'Řádky',
	'suppressColumns': 'Sloupce',
	'enableSuppression': 'Aktivovat potlačení',
	'disableSuppression': 'Deaktivovat potlačení',
	'loadVisDefinitionError': 'Nelze načíst definici pro vizualizaci %{id}',
	'emptyVisualization': 'Prázdná vizualizace',
	'expandCollapse': 'Rozbalit/sbalit',
	'expandBtnLabel': 'Rozbalit',
	'collapseBtnLabel': 'Sbalit',
	'prop_sizeInputNonNumericValue': 'Hodnotou musí být číslo.',
	'prop_sizeValueShouldBeHigher': 'Hodnota musí být větší než %{value}.',
	'fontPropLabel': 'Rodina písem',
	'fontSizePropLabel': 'Velikost písma',
	'sectionItemAxisTitle': 'Nadpis osy položek',
	'sectionItemAxisLabel': 'Popisek osy položek',
	'sectionValueAxisTitle': 'Nadpis osy hodnot',
	'sectionValueAxisLabel': 'Popisek osy hodnot',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Vizualizace',
	'ds-missingDataSet': 'Datovou sadu nelze najít. Ujistěte se, že datová sada byla úspěšně vytvořena.',
	'ds-missingDashboardId': 'Před vytvořením datové sady uložte panel dashboard.',
	'ds-unsupportedDataSourceType': 'Typ zdroje dat %{type} není podporován.'
});
